import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { approveOrRejectPurchaseRequest, getPurchaseRequestById } from "../../../../redux/features/purchaseRequest/purchaseRequestService";
import FilterDropdown from "../../../../components/FilterDropdown";
import { showToast } from "../../../../components/ToastMsg";

const formatNumber = (value) =>
    new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);

const requestStatus = [
    { id: 'Approved', name: 'Approved' },
    { id: 'Reject', name: 'Reject' },
    { id: 'Pending', name: 'Pending' },
]

const PurchaseRequestDetails = () => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const approveDropdownRef = useRef();

    const { selectedRequest } = useSelector((state) => state.purchaseRequest.selectedRequest);

    const [disabledBtn, setBtnDisable] = useState(false);
    const [statusErr, setStatusErr] = useState(null);
    const [reasonErr, setReasonErr] = useState(null);

    const fetchCourseBatch = async () => {
        try {
            await dispatch(getPurchaseRequestById({ id })).unwrap();
        } catch (error) {
            showToast('error', 'Unable to fetch batch information.');
        }
    }

    useEffect(() => {
        if (id) {
            fetchCourseBatch();
        }
    }, [id]);

    const submitRequestDecision = async () => {
        try {
            if (!selectedStatus) {
                setStatusErr('Request status is required.');
                return;
            }
            const date = new Date();
            if (selectedStatus === 'Reject') {
                if (!reason) {
                    setReasonErr('Reason is required.');
                    return;
                }
                const response = await dispatch(
                    approveOrRejectPurchaseRequest({ id: id, status: 'Reject', approved_date: date, reason: reason }),
                ).unwrap();
            }
            setBtnDisable(true);
            const response = await dispatch(
                approveOrRejectPurchaseRequest({ id: id, status: 'Approved', approved_date: date }),
            ).unwrap();
            showToast("success", response.message);
            setBtnDisable(false);
            if (approveDropdownRef.current) {
                approveDropdownRef.current.clearSelection();
            }
            setStatusSelect(null);
            setReason(null);
        } catch (error) {
            showToast("error", error.message);
            setBtnDisable(false);
        }
    };

    const [selectedStatus, setStatusSelect] = useState(null);
    const [reason, setReason] = useState(null);

    const handleRequestStatus = (option) => {
        setStatusSelect(option);
        setStatusErr(null);
    }

    return (
        <div className="card-section">
            <div className="main-card">
                <div className={styles.personalSec}>
                    <div className={styles.imgSec}>
                        <img className={styles.profileImg} src={selectedRequest?.order?.user?.image_url} alt="Profile" />
                    </div>
                    <div className={styles.personalDetailsSec}>
                        <p>{selectedRequest?.order?.user?.full_name}</p>
                        <p>{selectedRequest?.order?.user?.email}</p>
                        <p>{selectedRequest?.order?.user?.phone_number}</p>
                        <p className={`status-text-label ${selectedRequest?.status?.toLowerCase()}`}>{selectedRequest?.status}</p>
                    </div>
                </div>
            </div>
            <div className="main-card">
                <h1 className={`form-title`}>Purchase Request Details</h1>
                <div className={styles.slipDetails}>
                    <div className={styles.formContainer}>
                        <p>{selectedRequest?.course?.title}</p>
                        <p>Course Fee: {formatNumber(selectedRequest?.course?.price)}</p>
                        <p>Discount Price: {formatNumber(selectedRequest?.course?.discount_price)}</p>
                        <p>Order Amount: {formatNumber(selectedRequest?.order?.amount)}</p>
                        <img src={selectedRequest?.pay_slip} alt="pay slip" className={styles.slipImgMobile} />
                        <form className={styles.coordinatorForm} noValidate>
                            <div className="form-input-row">
                                <div className="form-input-col">
                                    <div className="form-input-group">
                                        <label className="form-label">
                                            Approve/ Reject<span className="required-star">*</span>
                                        </label>
                                        <FilterDropdown
                                            ref={approveDropdownRef}
                                            options={requestStatus}
                                            placeholder="Select a Status"
                                            onSelect={(option) => handleRequestStatus(option.id)}
                                            value={selectedStatus}
                                        />
                                        {statusErr && (
                                            <p className={`text-danger`}>{statusErr}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {selectedStatus === 'Reject' &&
                                <div className="form-input-row">
                                    <div className="form-input-col">
                                        <div className="form-input-group">
                                            <label className="form-label">
                                                Reason<span className="required-star">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="reason"
                                                value={reason}
                                                placeholder="Enter the reason"
                                                className="form-input-default"
                                                onChange={(e) => {
                                                    setReason(e.target.value);
                                                    setReasonErr(null);
                                                }}
                                            />
                                            {reasonErr && (
                                                <p className={`text-danger`}>{reasonErr}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            }
                            <button
                                className="btn-primary"
                                type="button"
                                disabled={disabledBtn}
                                onClick={submitRequestDecision}
                            >
                                {disabledBtn ? <span>Loading...</span> : `Create`}
                            </button>
                        </form>
                    </div>
                    <img src={selectedRequest?.pay_slip} alt="pay slip" className={styles.slipImg} />
                </div>
            </div>
        </div>
    );
};

export default PurchaseRequestDetails;